import { schema } from "normalizr";
import teamSchema from "./team";

const userSchema = new schema.Entity(
    "users",
    {
        teams: [teamSchema],
        team: teamSchema
    },
    { idAttribute: "id" }
);

export default userSchema;



// WEBPACK FOOTER //
// ./src/schemas/user.js